<script setup lang="ts">
import agentSm from "~/assets/icons/agent/agent-sm.svg?url"

const { conversationsByUpdatedAt } = useConversations()
const { onCreateOrOpenLatestConversationIntent } = useAgent()

// list items in this folder, and have a listener that watches for
// content changes
</script>

<template>
  <sidebar-entry-item>
    <template #item>
      <div class="agent-item" @click="onCreateOrOpenLatestConversationIntent(true)">
        <div>
          <img :src="agentSm" class="agent-icon">
        </div>
        <div>
          Agent
        </div>
      </div>
    </template>
    <template #contents>
      <div class="entry-conversation-list">
        <sidebar-entry-conversation
          v-for="conversation in conversationsByUpdatedAt"
          :key="conversation.id"
          :conversation
          class="entry-conversation-list-item"
        />
      </div>
    </template>
  </sidebar-entry-item>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.agent-button
  @apply flex items-center gap-0.5
  @apply text-[#{$sidebar-t-item}] t-sidebar-item
  @apply -m-1 p-1 my-0 rounded-[#{$sidebar-br-item-hovered}]
  @apply cursor-pointer
  &:not(.isDragging):hover
    @apply bg-[#{$sidebar-bg-item-hovered}]

.agent-icon
  @apply w-4.5 h-4.5

.agent-item
  @apply flex items-center gap-[#{$sidebar-gap-item}]

.entry-file-chevron
  @apply
  @apply text-[#{$global-steel-primary}]
  @apply -ml-0.5
  &:hover
    @apply text-white

.entry-conversation-list
  @apply pl-[#{$sidebar-pl-indent}]

.entry-conversation-list-item
  @apply mt-[#{$sidebar-gap-content-section}]
</style>
